import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useNextGenAuth } from '../context/NextGenAuthContext';

/**
 * NextGenPaidFeatureGuard
 *
 * Feature-based billing (26-Aug-2026): AI Tutor, Elite Mastery and Mock
 * Interview are no longer unlocked wholesale by a TSG Nexus plan. Every
 * builder gets a free allowance per feature and buys more per feature, and
 * the allowance is enforced SERVER-SIDE on every request (tsgroutes,
 * aiServices and eliteRoutes consult the shared billing layer). This guard
 * therefore only requires a signed-in builder; it never decides what the
 * builder may consume — that answer comes back from the API as a
 * structured 402 which opens the purchase modal.
 *
 * Builders whose plan was bought before the launch keep full access until
 * its original expiry through billing_legacy_access_grants (server-side).
 */
const NextGenPaidFeatureGuard = ({ children }) => {
  const auth = useNextGenAuth();
  const location = useLocation();
  const builder = auth && (auth.builder || auth.nextgen_builder);
  if (!builder) {
    return <Navigate to="/nextgen-builder/login" replace state={{ from: location.pathname }} />;
  }
  return children;
};

export default NextGenPaidFeatureGuard;
